module.exports = __webpack_public_path__ + "img/mIconTableLayer.3cb94e3a.svg";